module.exports = __webpack_public_path__ + "img/reka.975cb808.svg";